export default __webpack_public_path__ + "static/media/prompt.d2198bb9.png";